<script>
import {GuestTestDataProvider} from '../../sevices/GuestTestDataProvider';

export default {
    name: "PublicTest",
    props: ['testId'],
    data() {
        return {
            dataProvider: null,
        }
    },
    created() {
        this.dataProvider = new GuestTestDataProvider();
        this.$router.push({name: 'before-start', params: {testId: this.$props.testId, dataProvider: this.dataProvider}});
    },
    methods: {
    }
}
</script>
<template>
    <div>
        <router-view></router-view>
    </div>
</template>
